import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/globals.css'
import i18n from './i18n'
import { initializeSecurity } from './lib/security'
import { logger } from './lib/logger'

// Security only here — GA/Clarity deferred via App + idle index.html loader (CWV)
if (import.meta.env.PROD) {
  initializeSecurity();
} else {
  logger.debug('[Security DEV] Development mode - minimal security enabled');
}

// [PHASE 4 RESTORE] Firebase Performance Monitoring disabled — GCP project suspended
// import { app, performance } from './firebase'
// import { trace } from "firebase/performance"
// let hydrationTrace = null;
// if (performance && import.meta.env.PROD) {
//   try {
//     hydrationTrace = trace(performance, 'react_hydration');
//     hydrationTrace.start();
//   } catch (error) { /* silently fail */ }
// }

// 🎯 CRITIQUE : Attendre que i18next soit COMPLÈTEMENT initialisé avant de rendre React
// Cela résout la race condition où React rend avant que les traductions soient chargées

// Fonction pour rendre l'application
const renderApp = () => {
  document.documentElement.classList.add('js-ready');

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

  (window as any).__REACT_LOADED__ = true;
};

// Vérifier si i18next est déjà initialisé
if (i18n.isInitialized) {
  renderApp();
} else {
  // Sinon, attendre l'événement initialized
  i18n.on('initialized', () => {
    renderApp();
  });
  
  // Timeout de sécurité : si i18next ne s'initialise pas en 5 secondes, rendre quand même
  setTimeout(() => {
    if (!document.getElementById('root')?.hasChildNodes()) {
      renderApp();
    }
  }, 5000);
}
